module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_a_positivo-e34d6efad1ceb1affce069b1f794eca5.svg";